import { TEntity } from '@yard/app/models/entity.model'
import { makeObservable, observable, runInAction } from 'mobx'

export class BaseEntityStore<T extends TEntity> {
  items: T[] = []

  constructor() {
    makeObservable(this, {
      items: observable,
    })
  }

  updateStoreItems(items: T[]) {
    runInAction(() => {
      this.items = items ?? []
    })
  }

  upsertStoreItems(items: T[]) {
    runInAction(() => {
      this.items = [...this.items.filter(i => !items.some(item => item.id === i.id)), ...items]
    })
  }

  updateStoreItem(item: T, id: number | string) {
    const existingItems = this.items.find(i => i.id === id)
    runInAction(() => {
      if (existingItems) this.items = this.items.map(i => (i.id === id ? item : i))
      else {
        this.items.push(item)
        this.items = [...this.items] //This is necessary, otherwise mobx does not update the items array correctly when updateStoreItem & deleteStoreItem(s) called in same time
      }
    })
  }

  deleteStoreItem(id: number | string) {
    runInAction(() => {
      this.items = this.items.filter(i => i.id !== id)
    })
  }
}
